import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { ComplaintProvider } from "../contexts/ComplaintContext";
import { DialogProvider } from "../contexts/DialogContext";
import { UserProvider } from "../contexts/UserContext";
import { ComplaintTypeProvider } from "../contexts/ComplaintTypeContext";
import { EmployeeProvider } from "../contexts/EmployeeContext";
import { TenantProvider } from "../contexts/TenantContext";

export const ComplaintComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <ComplaintProvider key={0} />,
        <UserProvider key={1} />,
        <ComplaintTypeProvider key={2} />,
        <EmployeeProvider key={3} />,
        <TenantProvider key={4} />,
        <DialogProvider key={5} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
